export const FETCH_LESSON_TYPES = "FETCH_LESSON_TYPES";